import * as jsxRuntime from "/home/runner/work/misode.github.io/misode.github.io/node_modules/preact/jsx-runtime/dist/jsxRuntime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment